import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const column1 = ["Shoes", "Hoodies/Sweaters", "T-Shirts", "Jackets", "Pants/Shorts"];
  const column2 = ["Headwear", "Sets", "Underwear/Underpants", "Jersey"];
  const column3 = ["Accessories", "Bags", "Belts", "Perfumes", "OtherStuff"];

  const categoryUrls: Record<string, string> = {
    "Shoes": "https://kaspreadsheet.com/category-911-Shoes.html",
    "Hoodies/Sweaters": "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    "T-Shirts": "https://kaspreadsheet.com/category-913-T-Shirts.html",
    "Jackets": "https://kaspreadsheet.com/category-914-Jackets.html",
    "Pants/Shorts": "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    "Headwear": "https://kaspreadsheet.com/category-916-Headwear.html",
    "Sets": "https://kaspreadsheet.com/category-917-Sets.html",
    "Underwear/Underpants": "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    "Jersey": "https://kaspreadsheet.com/category-919-Jersey.html",
    "Accessories": "https://kaspreadsheet.com/category-920-Accessories.html",
    "Bags": "https://kaspreadsheet.com/category-921-Bags.html",
    "Belts": "https://kaspreadsheet.com/search-922/name/Bags.html",
    "Perfumes": "https://kaspreadsheet.com/search-923/name/Bags.html",
    "OtherStuff": "https://kaspreadsheet.com/search-924/name/Bags.html",
  };

  return (
    <footer className="bg-accent-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 leading-tight">
              {t("footer.brand")}
              <br />
              {t("footer.brand_sub")}
            </h2>
            <p className="mt-4 text-sm text-background-100/50 leading-relaxed">
              {t("footer.description")}
            </p>

            <div className="mt-8">
              <form
                data-readdy-form
                action="https://readdy.ai/api/form/d8se0r8n4gr6p3b2gmrg"
                method="POST"
                encType="application/x-www-form-urlencoded"
                id="newsletter-form"
              >
                <label htmlFor="newsletter-email" className="block text-xs font-medium text-background-100/60 mb-2">
                  {t("footer.newsletter_label")}
                </label>
                <div className="flex flex-col sm:flex-row gap-2">
                  <input
                    type="email"
                    name="email"
                    id="newsletter-email"
                    placeholder={t("footer.newsletter_placeholder")}
                    required
                    className="flex-1 bg-transparent border-b border-background-100/30 px-0 py-2 text-sm text-background-50 placeholder:text-background-100/30 focus:outline-none focus:border-background-100/60 transition-colors"
                  />
                  <button
                    type="submit"
                    className="px-5 py-2 rounded-full border border-background-100/30 text-sm text-background-50 font-medium cursor-pointer whitespace-nowrap hover:bg-background-100/10 transition-colors"
                  >
                    {t("footer.subscribe")}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="lg:w-3/5 grid grid-cols-3 gap-6 md:gap-10">
            <div>
              <h4 className="text-xs font-semibold text-background-100/50 tracking-wider uppercase mb-4">
                {t("footer.column1_title")}
              </h4>
              <ul className="space-y-2.5">
                {column1.map((name) => (
                  <li key={name}>
                    <a
                      href={categoryUrls[name]}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-100/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-background-100/50 tracking-wider uppercase mb-4">
                {t("footer.column2_title")}
              </h4>
              <ul className="space-y-2.5">
                {column2.map((name) => (
                  <li key={name}>
                    <a
                      href={categoryUrls[name]}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-100/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-background-100/50 tracking-wider uppercase mb-4">
                {t("footer.column3_title")}
              </h4>
              <ul className="space-y-2.5">
                {column3.map((name) => (
                  <li key={name}>
                    <a
                      href={categoryUrls[name]}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-100/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/40">
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://oopbuyspreadsheets.mom/"
              className="text-xs text-background-100/40 hover:text-background-100/60 transition-colors cursor-pointer"
            >
              Home
            </a>
            <a
              href="https://oopbuyspreadsheets.mom/"
              className="text-xs text-background-100/40 hover:text-background-100/60 transition-colors cursor-pointer"
            >
              Privacy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}